import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { BillingStatusCodes } from '@common/known-types/billing-status.codes';
import { ContractStatusCodes } from '@common/known-types/contract-status.codes';
import { InvoiceStatusCodes } from '@common/known-types/invoice-status.codes';

@Directive({
    selector: '[pill]'
})
export class PillDirective implements OnChanges {
    // colors
    dark = '#222';
    light = '#fff';
    grey = '#ced4da';
    yellow = '#ffc107';
    amber = '#ffc000';
    orange = '#fd9a47';
    green = '#5dd879';
    lightblue = '#add8e6';
    middleblue = '#5d9ce6';
    blue = '#59a9ff';
    darkgrey = '#666';
    red = '#e56b77';
    purple = '#9b78e3';

    // status, module & muted input
    @Input() pill: { status: string; module: string };

    el: ElementRef;

    constructor(el: ElementRef) {
        this.el = el;
    }

    ngOnChanges() {
        const backgroundColor = this.pillColor(this.pill);
        this.el.nativeElement.style.backgroundColor = backgroundColor;
        this.el.nativeElement.style.color = this.backgroundToForeground(backgroundColor);
    }

    private backgroundToForeground(color: string): string {
        return [this.dark, this.darkgrey].includes(color) ? this.light : this.dark;
    }

    private pillColor(input: any): string {
        const status = input.status?.toUpperCase();

        if (this.pill.module === 'BillingStatus') {
            switch (status) {
                case BillingStatusCodes.Active:
                    return this.green;
                case BillingStatusCodes.Billed:
                    return this.blue;
                case BillingStatusCodes.Completed:
                    return this.amber;
                case BillingStatusCodes.NonBillable:
                    return this.purple;
                case BillingStatusCodes.PartiallyBilled:
                    return this.yellow;
            }
        } else if (this.pill.module === 'InvoiceStatus') {
            switch (status) {
                case InvoiceStatusCodes.Issued:
                    return this.blue;
                case InvoiceStatusCodes.Cancelled:
                    return this.red;
                case InvoiceStatusCodes.Rejected:
                    return this.orange;
                case InvoiceStatusCodes.WaitingApproval:
                    return this.amber;
                case InvoiceStatusCodes.RejectedByPoint:
                    return this.purple;
            }
        } else if (this.pill.module === 'ContractStatus') {
            switch (status) {
                case ContractStatusCodes.Active:
                    return this.green;
                case ContractStatusCodes.Cancelled:
                    return this.yellow;
                case ContractStatusCodes.Expired:
                    return this.orange;
                case ContractStatusCodes.Terminated:
                    return this.red;
            }
        } else {
            switch (status) {
                case 'TB':
                case 'ANC':
                case 'DRA':
                    return this.yellow;

                case 'RFU':
                case 'NTM':
                    return this.amber;

                case 'BU':
                case 'WFA':
                case 'RTE':
                    return this.orange;

                case 'AC':
                case 'APP':
                case 'RLS':
                case 'INP':
                    return this.green;

                case 'ARR':
                case 'WIP':
                case 'RTL':
                    return this.lightblue;

                case 'RTD':
                    return this.middleblue;

                case 'COM':
                case 'DEP':
                case 'LTP':
                    return this.blue;

                case 'EX':
                case 'DT':
                case 'CAN':
                    return this.darkgrey;

                case 'BN':
                case 'IA':
                case 'REJ':
                    return this.red;
            }
        }

        return this.grey;
    }
}
